import { Button, Col, Form, Input, Modal, Row, Select, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import Swal from "sweetalert2";

function CustomerModal({ visible, modalClose, center_id}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [districts, setDistrict] = useState([]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/api/districts/`, {
        headers: authHeader(),
      })
      .then((response) => setDistrict(response?.data))
      .catch((error) => console.log(error));
  }, []);

  const handleCustomerModalClose = () => {
    modalClose();
    form.resetFields();
  };

  const handleSubmit = (value) => {
    value.center_id = center_id;
    axios
      .post(`${config.baseUrl}/inventory/create_regular_customer/`, value, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response?.status === 201) {
          Swal.fire({
            title: "Success",
            text: "Customer Created Successful",
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            handleCustomerModalClose();
          });
        }
      })
      .catch((error) => {
        console.log(error)
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.[0],
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };

  return (
    <Modal
      title="Add Customer"
      open={visible}
      onCancel={handleCustomerModalClose}
      footer={false}
    >
      <Form
        form={form}
        color="#46604A"
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="customer_name"
              label="Customer Name"
              rules={[
                {
                  required: true,
                  message: "Customer name required",
                },
              ]}
            >
              <Input placeholder="Enter customer name"></Input>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="customer_phone"
              label="Customer Phone"
              rules={[
                {
                  required: true,
                  message: "Customer phone number required",
                },
                {
                  pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                  message: "Please enter a valid phone number",
                },
              ]}
            >
              <Input
                placeholder="Enter phone number"
                inputMode="numeric"
              ></Input>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              name="district_name"
              label="District"
              rules={[
                {
                  required: true,
                  message: "District required",
                },
              ]}
            >
              <Select placeholder="Select District" showSearch>
                {districts?.map((district) => (
                  <Option
                    value={district?.district_name}
                    key={district?.district_id}
                  >
                    {district?.district_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item name="address" label="Address">
              <TextArea placeholder="Enter Address"></TextArea>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="d-flex justify-content-end ">
          <Button
            htmlType="submit"
            disabled={loading}
            style={{ color: "#ffffff", backgroundColor: "#46604A" }}
          >
            Submit
            {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default CustomerModal;
